const PREPAID_STATE_COLLECTION = "prepaid_state";

const populateSnapshots = (snapshots) => {
  const docs = [];
  snapshots.forEach((snap) => {
    docs.push(extractSnapshotData(snap));
  });
  return docs;
};

const extractSnapshotData = (snap) => {
  if (!snap.exists) {
    return null;
  }

  return {
    id: snap.id,
    ...snap.data()
  };
};

function PrepaidStateMixin() {
  return {
    async getAllPrepaidStates() {
      const prepaidStates = await this.collection(PREPAID_STATE_COLLECTION)
        .get()
        .then(populateSnapshots);
      return prepaidStates;
    },

    async getActivePrepaidStatesByOrgaId(orgaId) {
      const today = new Date().toISOString();
      const prepaidStates = await this.collection(PREPAID_STATE_COLLECTION)
        .where("orgaId", "==", orgaId)
        .where("balance", ">", 0)
        .where("expirationDate", ">", today)
        .orderBy("createdDate", "asc")
        .get()
        .then(populateSnapshots);

      return prepaidStates;
    },

    async getPrepaidStateById(id) {
      const snap = await this.collection(PREPAID_STATE_COLLECTION).doc(id).get();
      return extractSnapshotData(snap);
    },

    async createPrepaidState(data) {
      const ref = await this.collection(PREPAID_STATE_COLLECTION).add(data);
      return {
        id: ref.id,
        ...data
      };
    },

    async updatePrepaidState(id, data) {
      await this.collection(PREPAID_STATE_COLLECTION).doc(id).update(data, { merge: true });
      return {
        id,
        ...data
      };
    }
  };
}

module.exports = PrepaidStateMixin;
